import './Documents.scss';

import React, {Component} from 'react';

import UploadCvForm from '../../../../components/Forms/UploadCvForm/UploadCvForm.jsx';
import FormGlobalErrors from '../../../../components/Form/FormGlobalErrors.jsx';
import UploadSkillsFileForm from "../../../../components/Forms/UploadSkillsFileForm/UploadSkillsFileForm.jsx";

import {prepareFreelanceBeforeSubmit} from '../../../../../shared/services/freelanceService';
import {prepareUserBeforeSubmit} from '../../../../../shared/services/userService';

import './Documents.scss';
import api from "../../../../../api.js";
import { format } from 'date-fns';
import {downloadFile} from "../../../../services/downloadService.js";
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx";
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx";
import Loader from "../../../../../shared/components/Loader/Loader.jsx";
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

export default class Documents extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      errors: null,
    };
  }
  onSubmitSuccess = async () => {
    try {
      this.setState({ loading: true, errors: null });
      await this.props.submit({
        user: prepareUserBeforeSubmit(this.props.user),
        freelance: prepareFreelanceBeforeSubmit(this.props.freelance),
      });
    } catch(e) {
      console.warn(e);
      this.setState({ errors: e.errors });
    } finally {
      this.setState({ loading: false });
      this.props.onFormSuccess();
    }
  };

  onUploadSuccess = async(cv) => {
    try {
      await this.props.submit({
        freelance: {
          ...prepareFreelanceBeforeSubmit(this.props.freelance),
          cv
        },
        user: prepareUserBeforeSubmit(this.props.user),
      });
    } catch(e) {
      console.warn(e);
    }
  };

  onCvNormalizedDownloaded = async () => {
    this.setState({loading: true});
    this.downloadCvNormalized()
      .finally(() => {
        this.setState({loading: false});
      })
  };

  downloadCvNormalized = () => {
    return api.freelances.cv.getNormalized({
      freelance: this.props.freelance.id
    })
      .then((blob) => {
        const firstname = this.props.user?.firstname ?? '';
        const freelanceId = this.props.freelance?.id ?? 0;
        const dateFormatted = format(new Date(), 'yyyyMMdd');
        const name = `${dateFormatted}-CV_Twineeds-${firstname}-${freelanceId}`;
        return downloadFile(blob, name, 'pdf');
      })
      .catch((err) => console.warn(err));
  };

  render() {
    const {user, freelance, isAdmin} = this.props;

    return (
      <FreelancePage className="step-upload-cv">
        <Loader visible={!!this.state.loading}>Téléchargement du DC ...</Loader>
        <h2 className="text-center">Documents</h2>

        <h5 id="cv" className="text-center py-4"> Mon CV</h5>
        <FormGlobalErrors errors={this.state.errors}/>

        <UploadCvForm
          className="upload-container"
          onSubmitSuccess={this.onSubmitSuccess}
          onUploadSuccess={this.onUploadSuccess}
          cv={freelance?.cv ?? null}
          freelanceId={user?.freelance_id ?? 0}
        />

        <h5 id="skill-folder" className="text-center pb-4 pt-5"> Dossier de compétences </h5>

        <CardRow direction="column" justify="center" align="center" gap="20px">
          <CardCol>
            Télécharger votre dossier de compétences Twineeds au format PDF :
          </CardCol>
          <CardCol>
            <button className="btn btn-primary" onClick={this.onCvNormalizedDownloaded}>
              DC Français
            </button>
          </CardCol>
        </CardRow>

        {isAdmin &&
          <CardRow  className="pb-4 pt-5" direction="column" justify="center" align="center" gap="20px">
            <CardCol>
              <UploadSkillsFileForm
                className="upload-container"
                freelanceId={user?.freelance_id ?? 0}
                onSubmitSuccess={this.onSubmitSuccess}
                onUploadSuccess={this.onUploadSuccess}
                onDeleteSuccess={this.onDeleteSkillsFileSuccess}
                skillsFile={this.props.freelance?.skills_file ?? null}
              />
            </CardCol>
          </CardRow>
        }
      </FreelancePage>
    );
  }
}
